import { useState } from "react";
import { FaCalendarAlt } from "react-icons/fa";
//---------------------------------------------
export default function ScheduleButton() {
  const [showModal, setShowModal] = useState(false);

  return (
    <div className="flex flex-col items-start">
      <button 
        onClick={() => setShowModal(true)} 
        className="mt-2 flex items-center gap-2 text-white text-lg font-semibold self-start ml-2"
      >
        <FaCalendarAlt className="text-5xl text-[var(--secondryColor)]" />
        <span className="ml-3">Schedule a call</span>
      </button>

      {showModal && (
        <div className="fixed top-0 left-0 w-full h-full flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-gray-900 text-white p-6 rounded-lg shadow-lg max-w-md w-full relative">
            <h2 className="text-2xl font-bold mb-4 text-center">Book a Call</h2>

            <button
              onClick={() => setShowModal(false)}
              className="absolute top-2 right-3 text-[var(--secondryColor)] text-2xl font-bold hover:text-red-500 transition-all duration-300"
            >
              &times;
            </button>

            <iframe
              src="https://calendly.com/mohanednagaty06/30min"
              className="w-full h-96 border-none rounded-lg"
            ></iframe>
          </div>
        </div>
      )}
    </div>
  );
}
